/**
 * @ngdoc controllers
 * @memberof mercury.modules.time
 * @name TimeRosterOverviewCtrl
 */
angular.module('mercury.modules.time.roster')
.controller('TimeRosterOverviewCtrl', ["$filter", "$q", "reporttime", "$scope", "title", "TimeClock", "TimeRosteredShifts", "userinfo", "shiftHelpers", function($filter, $q, reporttime, $scope, title, TimeClock, TimeRosteredShifts, userinfo, shiftHelpers) {
  title.set('Staff Roster');

  reporttime.defaultType = 'week';

  $scope.loading = $q.all({
    rosteredShifts: TimeRosteredShifts.getAll(reporttime.start(), reporttime.end()),
    clocks: TimeClock.getAllActiveAndClockedIn(reporttime.start(), reporttime.end())
  });

  $scope.payrollPermission = userinfo.companyHasPermission('Payroll');

  var totalPeriodCost = function(values, start, end) {
    var totalCost = 0;
    angular.forEach(values, function(value) {
      if (moment(value.clockinTime).isBefore(end) && moment(value.clockoutTime).isAfter(start)) {
        var effectiveStart = moment.max(moment(value.clockinTime), moment(start));
        var effectiveEnd = moment.min(moment(value.clockoutTime), moment(end));

        // Calculate the total unpaid break duration using the helper function
        var totalUnpaidBreakDuration = shiftHelpers.calculateTotalUnpaidBreakDuration(value);

        // Subtract the total unpaid break duration from the total cost length which is in hours
        periodDifference = effectiveEnd.diff(effectiveStart, 'minutes') / 60;
        totalCostLength = periodDifference >= totalUnpaidBreakDuration ? (periodDifference - totalUnpaidBreakDuration) : periodDifference;
        totalCost += totalCostLength * value.adjustedHourlyRate;
      }
    });
    return totalCost;
  };

  var totalPeriodHours = function(values, start, end) {
    var totalHours = 0;
    angular.forEach(values, function(value) {
      if (moment(value.clockinTime).isBefore(end) && moment(value.clockoutTime).isAfter(start)) {
        var effectiveStart = moment.max(moment(value.clockinTime), moment(start));
        var effectiveEnd = moment.min(moment(value.clockoutTime), moment(end));

        totalHours += (effectiveEnd.diff(effectiveStart, 'minutes') / 60);

        // Calculate the total unpaid break duration using the helper function
        var totalUnpaidBreakDuration = shiftHelpers.calculateTotalUnpaidBreakDuration(value);

        // Subtract the total unpaid break duration from the total hours
        totalHours = totalHours >= totalUnpaidBreakDuration ? totalHours -= totalUnpaidBreakDuration : totalHours;

      }
    });
    return totalHours;
  };

  if ($scope.payrollPermission) {
    $scope.graphCols = [
      {label: 'Period', type: 'string', key: 'time', filter: 'reporttimeformat'},
      {label: 'Staff Cost Rostered', type: 'number', key: 'rosterCost', filter: 'currency'},
      {label: 'Staff Cost Actual', type: 'number', key: 'clockCost', filter: 'currency'}
    ];
    $scope.graphOptions = {
      vAxis: {
        format: '$#,###.##'
      },
      series: [
        {targetAxisIndex: 0, type: 'bars'},
        {targetAxisIndex: 0, type: 'bars'}
      ]
    };
  } else {
    $scope.graphCols = [
      {label: 'Period', type: 'string', key: 'time', filter: 'reporttimeformat'},
      {label: 'Staff Hours Rostered', type: 'number', key: 'rosterHours'},
      {label: 'Staff Hours Actual', type: 'number', key: 'clockHours'}
    ];
    $scope.graphOptions = {
      vAxis: {
        format: '#,###.##'
      },
      series: [
        {targetAxisIndex: 0, type: 'bars'},
        {targetAxisIndex: 0, type: 'bars'}
      ]
    };
  }

  var costGraph = function() {
    var graphData = [];
    for (var graphIter = moment(reporttime.start()); graphIter.isBefore(reporttime.end()); graphIter.mNextIteration(reporttime.reportType())) {
      graphData.push({
        time: graphIter.format(),
        rosterCost: totalPeriodCost($scope.rosteredShifts, graphIter, graphIter.clone().mNextIteration(reporttime.reportType())),
        clockCost: totalPeriodCost($scope.clocks, graphIter, graphIter.clone().mNextIteration(reporttime.reportType())),
        rosterHours: totalPeriodHours($scope.rosteredShifts, graphIter, graphIter.clone().mNextIteration(reporttime.reportType())),
        clockHours: totalPeriodHours($scope.clocks, graphIter, graphIter.clone().mNextIteration(reporttime.reportType()))
      });
    }
    return graphData;
  };

  var roleTotalsTable = function() {
    var rosteredGroupsByRole = {};
    angular.forEach($scope.rosteredShifts, function(rosteredShift) {
      if (!rosteredGroupsByRole[rosteredShift.roleId]) {
        rosteredGroupsByRole[rosteredShift.roleId] = {
          name: rosteredShift.roleName,
          rosteredShifts: []
        };
      }
      rosteredGroupsByRole[rosteredShift.roleId].rosteredShifts.push(rosteredShift);
    });

    var roleTotals = [];
    angular.forEach(rosteredGroupsByRole, function(roleGroup) {
      var roleTotalCost = totalPeriodCost(roleGroup.rosteredShifts, reporttime.start(), reporttime.end());
      var roleTotalHours = totalPeriodHours(roleGroup.rosteredShifts, reporttime.start(), reporttime.end());
      roleTotals.push({
        name: roleGroup.name,
        totalCost: roleTotalCost,
        percentCost: (roleTotalCost / $scope.totalRosterCost) * 100,
        totalHours: roleTotalHours,
        percentHours: (roleTotalHours / $scope.totalRosterLength) * 100
      });
    });
    return roleTotals;
  };

  var dayTotalsTable = function() {
    var dayTotals = [];
    for (var dayIter = moment(reporttime.start()); dayIter.isBefore(reporttime.end()); dayIter.add(1, 'day')) {
      dayTotals.push({
        day: dayIter.format(),
        rosterCost: totalPeriodCost($scope.rosteredShifts, dayIter, dayIter.clone().add(1, 'day')),
        clockClost: totalPeriodCost($scope.clocks, dayIter, dayIter.clone().add(1, 'day')),
        rosterHours: totalPeriodHours($scope.rosteredShifts, dayIter, dayIter.clone().add(1, 'day')),
        clockHours: totalPeriodHours($scope.clocks, dayIter, dayIter.clone().add(1, 'day'))
      });
    }
    return dayTotals;
  };

  $scope.loading.then(function(result) {
    $scope.rosteredShifts = result.rosteredShifts;
    $scope.clocks = result.clocks;

    $scope.totalRosterLength = totalPeriodHours($scope.rosteredShifts, reporttime.start(), reporttime.end());
    $scope.totalRosterCost = totalPeriodCost($scope.rosteredShifts, reporttime.start(), reporttime.end());
    $scope.totalClockinLength = totalPeriodHours($scope.clocks, reporttime.start(), reporttime.end());
    $scope.totalClockinCost = totalPeriodCost($scope.clocks, reporttime.start(), reporttime.end());

    $scope.graphData = costGraph();
    $scope.roleTotals = roleTotalsTable();
    $scope.dayTotals = dayTotalsTable();
  });
}]);
